import {t} from "@lingui/core/macro";
import * as SlateReact from "slate-react";

import {announceMessage} from "@khanacademy/wonder-blocks-announcer";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";
import {useMathEditorContext} from "@khan/guide-math-editor-context";
import {useGuideState} from "@khan/guide-state";
import {RequestInfo} from "@khan/shared-core";
import {insertMath} from "@khan/slate-helpers";
import {useLocation} from "@khan/urls";

import {MathInputIconButton} from "../icons/math-input-icon-button.tsx";

export interface Props {
    disabled: boolean;
    mathButtonEnabled: boolean | undefined;
}

export const MathInputButton = ({disabled, mathButtonEnabled}: Props) => {
    const editor = SlateReact.useSlate();
    const isMobile = RequestInfo.isMobile;
    const {isAnyActive: isAnyMathActive} = useMathEditorContext();
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    const {href} = useLocation();
    const threadId = useGuideState("threadId");
    const navigation = useGuideState("navigation");

    const handleMathInputClick = () => {
        if (!SlateReact.ReactEditor.isFocused(editor)) {
            SlateReact.ReactEditor.focus(editor);
        }
        insertMath(editor);
        publishAnalyticsEvent({
            eventType: "AiGuideMathInputBoxOpened",
            eventSchemaVersion: 3,
            aiGuideThreadId: threadId ?? "",
            currentPageURL: href ?? "",
            aiGuideNavigationId: navigation.id,
        });
        announceMessage({
            message: t`Math input added`,
            level: "polite",
        });
    };

    const mathInputDisabled =
        // Disable math input button if chat-input itself is disabled...
        disabled ||
        // or if learner is already within a math input
        isAnyMathActive;

    return (
        mathButtonEnabled && (
            <MathInputIconButton
                onClick={handleMathInputClick}
                disabled={mathInputDisabled}
                title="Add math to your message"
                isMobile={isMobile}
            />
        )
    );
};
